import type { HTMLAttributes } from 'react';
import React from 'react';
import styled from 'styled-components';

import { PopoverEvent } from './popover.constants';

type StyledTargetWrapperProps = {
  event: PopoverEvent;
  display?: 'inline' | 'inline-block' | 'block';
};

export const StyledTargetWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'event' && prop !== 'display',
})<StyledTargetWrapperProps>`
  display: ${(props) => props.display};
  cursor: ${(props) => (props.event === PopoverEvent.CLICK ? 'pointer' : 'default')};
`;

export type Props = StyledTargetWrapperProps & HTMLAttributes<HTMLDivElement>;

const TargetWrapper = React.forwardRef<HTMLDivElement, Props>((props, ref) => (
  <StyledTargetWrapper {...props} ref={ref} />
));

TargetWrapper.displayName = 'TargetWrapper';

export default TargetWrapper;
